import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { CssBaseline, LinearProgress, ThemeProvider } from "@mui/material";
import { AUTH_BYPASS } from "./auth/bypass";
import { useAppSession } from "./auth/useAppSession";
import InactivityModal from "./components/claim/modals/InactivityModal";
import Feedback from "./components/ui/Feedback";
import Footer from "./components/ui/Footer";
import Header from "./components/ui/Header";
import LoginPage from "./pages/Login";
import AppRoutes from "./routes/AppRoutes";
import { useThemeContext } from "./theme/ThemeContextProvider";

function App() {
  const { theme } = useThemeContext();
  const {
    user,
    fetchUser,
    loginError,
    showFeedback,
    setShowFeedback,
    completeAppLogin,
    logout,
  } = useAppSession();

  const onLoginButtonClick = () => completeAppLogin(true);

  const authenticatedTree = (
    <>
      <InactivityModal user={user} inactiveCallback={logout} />

      {!user && (
        <LoginPage callback={onLoginButtonClick} userNotKnown={loginError} />
      )}

      {user && <AppRoutes user={user} />}
    </>
  );

  if (fetchUser) {
    return <LinearProgress sx={{ margin: "50vh 50px 0 50px" }} />;
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="header">
        <Header user={user} onLogout={logout} />
      </div>

      <div className="content">
        {AUTH_BYPASS ? (
          authenticatedTree
        ) : (
          <>
            <UnauthenticatedTemplate>
              <LoginPage callback={onLoginButtonClick} userNotKnown={false} />
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>{authenticatedTree}</AuthenticatedTemplate>
          </>
        )}

        <Feedback type={showFeedback} onClose={setShowFeedback} />
      </div>

      <div className="footer">
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
